import React, { useState, useEffect } from "react";
import {
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBBtnGroup,
  MDBIcon,
  MDBContainer,
} from "mdbreact";
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from "axios";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import WarningBox from "../components/WarningBox";

import { toast, ToastContainer } from "mdbreact";

const AddEditChargeInclusion = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);

  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [frm, setValues] = useState({
    code: Number(0),
    deleted: false,
    usertoken: sessionStorage.getItem("msal.uc"),
    itemcode: { value: "0", label: "Please select a service or item" },
    quantity: 1,
    packagecode: props.packagecode,
    sellingprice: 0,
    parentcode: props.parentcode,
    salescode: props.salescode,
  });

  const [passwordShown, setPasswordShown] = useState(false);

  const [disabledClass, setDisabledClass] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;

      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    saveitem();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const loaditemdetails = () => {
    Axios.get(
      props.apiServer + "/loadchargeinclusiondetails?acode=" + props.code,
      bearer
    )
      .then((res) => {
        if (res.data !== "empty") {
          setValues({
            ...frm,
            code: props.code,
            quantity: res.data.quantity,
            deleted: res.data.deleted,

            itemcode: {
              value: res.data.itemcode,
              label: res.data.itemdescription,
            },
          });
        } else {
          console.log("No record");
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const saveitem = () => {
    const data = frm;

    Axios.post(props.apiServer + "/savechargeinclusion", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });
          props.refreshGrid();
          toast.info(res.data.message, {
            closeButton: false,
          });
        } else {
          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const deleteitem = () => {
    const data = frm;

    Axios.post(props.apiServer + "/deleteitem", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          props.refreshGrid();

          toast.info(res.data.message, {
            closeButton: false,
          });
        } else {
          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });
    if (selOption !== "3") {
      setDisabledClass(false);
    } else {
      setDisabledClass(true);
    }
  };

  const [itemsservicesoptions, setitemsservicesoptions] = useState([]);
  const getitemsservicesoptions = () => {
    Axios.get(props.apiServer + "/getitemsservicesoptions", bearer)
      .then((res) => {
        setitemsservicesoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  useMountEffect(getitemsservicesoptions);
  useMountEffect(loaditemdetails);

  return (
    <React.Fragment>
      <MDBContainer fluid>
        <MDBRow>
          <MDBCol md="12">
            {" "}
            {props.code === 0 ? (
              <>
                <h3
                  style={{
                    fontFamily: "Montserrat",
                    fontWeight: "400",
                  }}
                  className="display-5 black-text ml-1 pt-3"
                >
                  Add Inclusions Here:
                </h3>
              </>
            ) : (
              <>
                <h5
                  style={{
                    fontFamily: "Montserrat",
                    fontWeight: "400",
                  }}
                  className="display-5 dark-grey-text ml-1 pt-3"
                >
                  Edit Inclusion
                </h5>
              </>
            )}
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol>
            <form
              className="needs-validation"
              onSubmit={submitHandler}
              noValidate
            >
              <MDBRow hidden>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.code}
                    id="code"
                    label="code"
                    required
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="12">
                  <label className="grey-text">
                    <small>&nbsp;Item /Service</small>
                  </label>
                  <br />
                  <Select
                    placeholderText="Select Item / Service"
                    isSearchable
                    value={frm.itemcode}
                    onChange={handleChange("itemcode")}
                    options={itemsservicesoptions}
                    required
                    // className={disabled}
                  />

                  <div className="invalid-feedback ">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>

                  <br />
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.quantity}
                    id="quantity"
                    label="Qty"
                    type="number"
                    onChange={updateField}
                    disabled={disabledClass}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="12">
                  <MDBInput
                    id="deleted"
                    label="Deleted"
                    labelClass="font-weight-bold red-text"
                    type="checkbox"
                    checked={frm.deleted}
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="6">
                  <MDBBtn className="blue lighten-1" type="submit">
                    Save
                  </MDBBtn>{" "}
                </MDBCol>
                <MDBCol md="6"></MDBCol>
              </MDBRow>
            </form>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        autoClose={5000}
      />

      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default AddEditChargeInclusion;
